// src/i18n/en/reservationStates.ts
// English mirror of es/reservationStates.ts — see that file for the rationale.
export const reservationStates = {
  notStarted: 'Not started',
  preCheckInPartial: 'Pre-check-in partial',
  preCheckInDone: 'Pre-check-in done',
  arrivesToday: 'Arrives today',
  liveKiosk: 'At the kiosk',
  liveMobileKiosk: 'At the mobile kiosk',
  liveAirLobby: 'With reception (Air Lobby)',
  needsHelp: 'Needs help',
  checkedInKiosk: 'Checked in at the kiosk',
  checkedInMobileKiosk: 'Checked in at the mobile kiosk',
  checkedInAirLobby: 'Checked in with Air Lobby',
  keyDelivered: 'Key delivered',
  kioskLeftMidway: 'Left midway at the kiosk',
  noRecord: 'No check-in on record',
  inHouse: 'In house',
  departed: 'Departed',
};

export default reservationStates;
